import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetLongreadProducts = (longreadId?: string) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {
            if (longreadId) {
                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.longread)
                    .url('/api/longread/GetProducts')
                    .get()
                    .addQuery('idLongread', longreadId)
                    .send()
                    .then((r) => {
                        if (!r.ok) {
                            throw new Error(`HTTP ${r.status}`)
                        }
                        return r.json()
                    })
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
            }
        }, [longreadId])

        return [resp, isLoading, error];
    }import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetLongreadProducts = (longreadId?: string) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {
            if (longreadId) {
                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.longread)
                    .url('/api/longread/GetProducts')
                    .get()
                    .addQuery('idLongread', longreadId)
                    .send()
                    .then((r) => {
                        if (!r.ok) {
                            throw new Error(`HTTP ${r.status}`)
                        }
                        return r.json()
                    })
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
            }
        }, [longreadId])

        return [resp, isLoading, error];
    }